import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3589798956 from "../../../../../packages/component/src/components/nav/demo/demo1.js?loadDemo";
import legacyImportDemo_3361693807 from "../../../../../packages/component/src/components/nav/demo/demo2.js?loadDemo";
import legacyImportDemo_1599073838 from "../../../../../packages/component/src/components/nav/demo/demo3.js?loadDemo";
import legacyImportDemo_3105033065 from "../../../../../packages/component/src/components/nav/demo/demo4.js?loadDemo";
import legacyImportDemo_1812897064 from "../../../../../packages/component/src/components/nav/demo/demo5.js?loadDemo";
import legacyImportDemo_2914813803 from "../../../../../packages/component/src/components/nav/demo/demo6.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3589798956,
  legacyImportDemo_3361693807,
  legacyImportDemo_1599073838,
  legacyImportDemo_3105033065,
  legacyImportDemo_1812897064,
  legacyImportDemo_2914813803,
  React
};